import { docodeHexResponse } from '../../_common/common.utils';
import funderDetailsActionTypes from './funder-details.types';

const INITIAL_STATE = {
	getFunderDetailsListResponse: null,
	getFunderDetailsListArr: [],

	addFunderDetailsStatus: null,
	addFunderDetailsArr: [],

	updateFunderDetailsStatus: null,
	updateFunderDetailsArr: [],

	deleteFunderDetailsStatus: null,
	deleteFunderDetailsArr: [],

	fetchAllInvestmentRepaymentListResponse: null,
	fetchAllInvestmentRepaymentListArr: [],

	fetchInvestmentProductInvestmentAmountResponse: null,
	fetchInvestmentProductInvestmentAmountArr: [],

	fetchAllInvestmentMadeListResponse: null,
	fetchAllInvestmentMadeListArr: [],

	createInvestorMadeResp: null,
	createInvestorMadeArr: [],

	getInvestorDetailsResp: null,
	getInvestorsDetailsArr: [],

	getBranchAccountListResp: null,
	getBranchAccountListArr: [],

	GetRepaymentScheduleResp: null,
	GetRepaymentScheduleArr: [],
};

const funderDetailsReducer = (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** ***************** GET FUNDER DETAILS LIST START *********************** */
		case funderDetailsActionTypes.GET_FUNDER_DETAILS_LIST_SUCCESS:
			return {
				...state,
				getFunderDetailsListResponse: action.payload,
				getFunderDetailsListArr: docodeHexResponse(
					action.payload,
					'GetAllInvestorDetailsKey',
				),
			};

		case funderDetailsActionTypes.GET_FUNDER_DETAILS_LIST_FAILURE:
			return {
				...state,
				getFunderDetailsListResponse: action.payload,
				getFunderDetailsListArr: [],
			};

		case funderDetailsActionTypes.GET_FUNDER_DETAILS_LIST_CHANGED:
			return { ...state, getFunderDetailsListResponse: null };
		/** ***************** GET FUNDER DETAILS LIST END *********************** */

		/** ***************** ADD FUNDER DETAILS START *********************** */
		case funderDetailsActionTypes.ADD_FUNDER_DETAILS_SUCCESS:
			return {
				...state,
				addFunderDetailsStatus: action.payload,
				addFunderDetailsArr: docodeHexResponse(action.payload, 'AddFunderDetailsKey'),
			};

		case funderDetailsActionTypes.ADD_FUNDER_DETAILS_FAILURE:
			return { ...state, addFunderDetailsStatus: action.payload, addFunderDetailsArr: [] };

		case funderDetailsActionTypes.ADD_FUNDER_DETAILS_CHANGED:
			return { ...state, addFunderDetailsStatus: null };
		/** ***************** ADD FUNDER DETAILS END *********************** */

		/** ***************** UPDATE FUNDER DETAILS START *********************** */
		case funderDetailsActionTypes.UPDATE_FUNDER_DETAILS_SUCCESS:
			return {
				...state,
				updateFunderDetailsStatus: action.payload,
				updateFunderDetailsArr: docodeHexResponse(action.payload, 'UpdateFunderDetailsKey'),
			};

		case funderDetailsActionTypes.UPDATE_FUNDER_DETAILS_FAILURE:
			return {
				...state,
				updateFunderDetailsStatus: action.payload,
				updateFunderDetailsArr: [],
			};

		case funderDetailsActionTypes.UPDATE_FUNDER_DETAILS_CHANGED:
			return { ...state, updateFunderDetailsStatus: null };
		/** ***************** UPDATE FUNDER DETAILS END *********************** */

		/** ***************** DELETE FUNDER DETAILS START *********************** */
		case funderDetailsActionTypes.DELETE_FUNDER_DETAILS_SUCCESS:
			return {
				...state,
				deleteFunderDetailsStatus: action.payload,
				deleteFunderDetailsArr: docodeHexResponse(action.payload, 'DeleteFunderDetailsKey'),
			};

		case funderDetailsActionTypes.DELETE_FUNDER_DETAILS_FAILURE:
			return {
				...state,
				deleteFunderDetailsStatus: action.payload,
				deleteFunderDetailsArr: [],
			};

		case funderDetailsActionTypes.DELETE_FUNDER_DETAILS_CHANGED:
			return { ...state, deleteFunderDetailsStatus: null };
		/** ***************** DELETE FUNDER DETAILS END *********************** */
		/************** FETCH INVESTMENT PRODUCT INVESTMENT AMOUNT START ************************** */
		case funderDetailsActionTypes.FETCH_INVESTMENT_PRODUCT_INVESTMENT_AMOUNT_SUCCESS:
			return {
				...state,
				fetchInvestmentProductInvestmentAmountResponse: action.payload,
				fetchInvestmentProductInvestmentAmountArr: docodeHexResponse(
					action.payload,
					'FetchInvestmentProductInvestmentAmountKey',
				),
			};

		case funderDetailsActionTypes.FETCH_INVESTMENT_PRODUCT_INVESTMENT_AMOUNT_FAILURE:
			return {
				...state,
				fetchInvestmentProductInvestmentAmountResponse: action.payload,
				fetchInvestmentProductInvestmentAmountArr: [],
			};

		case funderDetailsActionTypes.FETCH_INVESTMENT_PRODUCT_INVESTMENT_AMOUNT_RESPONSE_CHANGED:
			return {
				...state,
				fetchInvestmentProductInvestmentAmountResponse: null,
			};

		/************** FETCH INVESTMENT PRODUCT INVESTMENT AMOUNT END ************************** */

		/************** FETCH ALL INVESTMENT MADE LIST START ************************** */
		case funderDetailsActionTypes.FETCH_ALL_INVESTMENT_MADE_LIST_SUCCESS:
			return {
				...state,
				fetchAllInvestmentMadeListResponse: action.payload,
				fetchAllInvestmentMadeListArr: docodeHexResponse(
					action.payload,
					'FetchAllInvestmentMadeListKey',
				),
			};

		case funderDetailsActionTypes.FETCH_ALL_INVESTMENT_MADE_LIST_FAILURE:
			return {
				...state,
				fetchAllInvestmentMadeListResponse: action.payload,
				fetchAllInvestmentMadeListArr: [],
			};

		case funderDetailsActionTypes.FETCH_ALL_INVESTMENT_MADE_LIST_RESPONSE_CHANGED:
			return {
				...state,
				fetchAllInvestmentMadeListResponse: null,
			};

		/************** FETCH ALL INVESTMENT MADE LIST END ************************** */

		/************** FETCH ALL INVESTMENT REPAYMENT LIST START ************************** */
		case funderDetailsActionTypes.FETCH_ALL_INVESTMENT_REPAYMENT_LIST_SUCCESS:
			return {
				...state,
				fetchAllInvestmentRepaymentListResponse: action.payload,
				fetchAllInvestmentRepaymentListArr: docodeHexResponse(
					action.payload,
					'FetchAllInvestmentRepaymentListKey',
				),
			};

		case funderDetailsActionTypes.FETCH_ALL_INVESTMENT_REPAYMENT_LIST_FAILURE:
			return {
				...state,
				fetchAllInvestmentRepaymentListResponse: action.payload,
				fetchAllInvestmentRepaymentListArr: [],
			};

		case funderDetailsActionTypes.FETCH_ALL_INVESTMENT_REPAYMENT_LIST_RESPONSE_CHANGED:
			return {
				...state,
				fetchAllInvestmentRepaymentListResponse: null,
			};

		/************** FETCH ALL INVESTMENT REPAYMENT LIST END ************************** */

		/************** CREATE INVESTOR MADE START ************************** */
		case funderDetailsActionTypes.CREATE_INVESTOR_MADE_SUCCESS:
			return {
				...state,
				createInvestorMadeResp: action.payload,
				createInvestorMadeArr: docodeHexResponse(action.payload, 'createInvestorMadeKey'),
			};

		case funderDetailsActionTypes.CREATE_INVESTOR_MADE_FAILURE:
			return {
				...state,
				createInvestorMadeResp: action.payload,
				createInvestorMadeArr: [],
			};

		case funderDetailsActionTypes.CREATE_INVESTOR_MADE_CHANGED:
			return { ...state, createInvestorMadeResp: null };

		/************** CREATE INVESTOR MADE END ************************** */

		/************** GET INVESTOR DETAILS START ************************** */
		case funderDetailsActionTypes.GET_INVESTORS_DETAILS_SUCCESS:
			return {
				...state,
				getInvestorDetailsResp: action.payload,
				getInvestorsDetailsArr: docodeHexResponse(action.payload, 'getInvestorDetailsKey'),
			};

		case funderDetailsActionTypes.GET_INVESTORS_DETAILS_FAILURE:
			return {
				...state,
				getInvestorDetailsResp: action.payload,
			};

		case funderDetailsActionTypes.GET_INVESTORS_DETAILS_CHANGED:
			return {
				...state,
				getInvestorDetailsResp: null,
				getInvestorsDetailsArr: [],
			};

		/************** GET INVESTOR DETAILS END ************************** */

		/************** GET INVESTOR DETAILS START ************************** */
		case funderDetailsActionTypes.GET_BRANCH_ACCOUNT_LIST_SUCCESS:
			return {
				...state,
				getBranchAccountListResp: action.payload,
				getBranchAccountListArr: docodeHexResponse(
					action.payload,
					'getBranchAccountListKey',
				),
			};

		case funderDetailsActionTypes.GET_BRANCH_ACCOUNT_LIST_FAILURE:
			return {
				...state,
				getBranchAccountListResp: action.payload,
				getBranchAccountListArr: [],
			};

		case funderDetailsActionTypes.GET_BRANCH_ACCOUNT_LIST_CHANGED:
			return {
				...state,
				getBranchAccountListResp: null,
			};

		/************** GET INVESTOR DETAILS END ************************** */

		/************** GET INVESTOR DETAILS START ************************** */
		case funderDetailsActionTypes.GET_REPAYMENT_SCHEDULE_SUCCESS:
			return {
				...state,
				GetRepaymentScheduleResp: action.payload,
				GetRepaymentScheduleArr: docodeHexResponse(
					action.payload,
					'getBranchAccountListKey',
				),
			};

		case funderDetailsActionTypes.GET_REPAYMENT_SCHEDULE_FAILURE:
			return {
				...state,
				GetRepaymentScheduleResp: action.payload,
				GetRepaymentScheduleArr: [],
			};

		case funderDetailsActionTypes.GET_REPAYMENT_SCHEDULE_CHANGED:
			return {
				...state,
				GetRepaymentScheduleResp: null,
			};

		/************** GET INVESTOR DETAILS END ************************** */

		default:
			return state;
	}
};

export default funderDetailsReducer;
